export const handleBrevoLinkResult = (
  result: { url: string | null },
  openWindow: (url: string, target: string) => void
) => {
  if (!result?.url) return false;
  openWindow(result.url, '_blank');
  return true;
};
